var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTareasNa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2419_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1786 1.40625C10.1786 0.626953 9.46205 0 8.57143 0C7.6808 0 6.96429 0.626953 6.96429 1.40625V3.75H4.28571C1.92188 3.75 0 5.43164 0 7.5V8.4375V11.25V26.25C0 28.3184 1.92188 30 4.28571 30H25.7143C28.0781 30 30 28.3184 30 26.25V11.25V8.4375V7.5C30 5.43164 28.0781 3.75 25.7143 3.75H23.0357V1.40625C23.0357 0.626953 22.3192 0 21.4286 0C20.5379 0 19.8214 0.626953 19.8214 1.40625V3.75H10.1786V1.40625ZM3.21429 11.25H26.7857V26.25C26.7857 26.7656 26.3036 27.1875 25.7143 27.1875H4.28571C3.69643 27.1875 3.21429 26.7656 3.21429 26.25V11.25Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2419_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTareasNa);
export default __webpack_public_path__ + "static/media/TareasNA.2a6d3b142a2c887fb460e76c7d538ba5.svg";
export { ForwardRef as ReactComponent };